import type { ThemeType } from '../schema';
import { getIsDarkTheme } from 'owa-fabric-theme';
import { getIsMsHighContrast } from 'owa-high-contrast';

export default function getThemeType(): ThemeType {
    return getIsMsHighContrast() ? 'HighContrast' : getIsDarkTheme() ? 'Dark' : 'Light';
}
